<template>
	<BaseCmsPage v-slot="{page}">
		<CmsHeroSlider />
		<CmsLatestPortfolio />
		<div class="wrapper categories">
			<LazyCatalogCategories hydrate-on-visible />
			<LazyCatalogPopularCategories hydrate-on-visible />
		</div>
		<LazyCatalogSpecialProducts hydrate-on-visible />
		<LazyPublishLatestPosts hydrate-on-visible />
		<LazyCmsAbout :content="page?.content" hydrate-on-visible />
		<LazyCatalogSpecialBrands hydrate-on-visible />
	</BaseCmsPage>
</template>

<style scoped lang="less">
	.categories{
		background: url(assets/images/bg.jpg) no-repeat center; background-size: cover; margin-top: 200px;
		@media (max-width: @m){background: #fff; margin-top: 0; padding: 0;}	
	}
	:deep(.categories-widget){
		@media (min-width: @m){.translate(0,-185px);}
	}
	:deep(.popular-categories){
		@media (min-width: @m){margin-top: -185px;}
		@media (max-width: @m){background: url(assets/images/bg.jpg) no-repeat center; background-size: cover;}
	}
</style>